import { render } from "./BaseCheckbox.vue?vue&type=template&id=575c5eb2"
import script from "./BaseCheckbox.vue?vue&type=script&lang=js"
export * from "./BaseCheckbox.vue?vue&type=script&lang=js"
script.render = render

export default script